import { AssetFile, AssetImage } from "gql/generated";
import { useState } from "react";

type UseUploadAvatarProps = {
  image?: Partial<AssetImage> | undefined;
  onUploadComplete: (assets: Partial<AssetFile | AssetImage>) => void;
  onRemoveClick: () => void;
};

export const useUploadAvatar = ({
  image,
  onUploadComplete,
  onRemoveClick,
}: UseUploadAvatarProps) => {
  const [avatar, setAvatar] = useState<
    Partial<AssetFile | AssetImage> | undefined
  >(image);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

  const handleRemoveAvatar = () => {
    setAvatar(undefined);
    onRemoveClick();
  };

  const handleUploadClick = () => {
    setIsUploadModalOpen(true);
  };

  /**
   * Handle the completion of the upload
   * - Set the current avatar to the newly uploaded asset
   * - Call the onUploadComplete callback with the newly uploaded asset
   * @param assets
   */
  const handleUploadComplete = (assets: Partial<AssetFile | AssetImage>[]) => {
    if (assets.length > 0) {
      setAvatar(assets[0]);
      onUploadComplete(assets[0]);
    }
    setIsUploadModalOpen(false);
  };

  return {
    avatar,
    setAvatar,
    isUploadModalOpen,
    setIsUploadModalOpen,
    onUploadClick: handleUploadClick,
    onUploadComplete: handleUploadComplete,
    onRemoveAvatar: handleRemoveAvatar,
  };
};
